
import api from './axios';
import { DocumentMetadata, UploadDocumentResponse } from './types'

const documentsApi = {

    // Upload Document
    async uploadDocument(file: File, businessSlug: string, docType: string): Promise<UploadDocumentResponse> {
        try {
            const formData = new FormData();
            formData.append('file', file);
            formData.append('business_slug', businessSlug);
            formData.append('doc_type', docType);

            console.log('DEBUG: Uploading document...', { file: file.name, type: file.type, businessSlug, docType });
            const res = await api.post('/documents/upload', formData);
            console.log('DEBUG: Upload success', res.data);

            return res.data;
        } catch (error: any) {
            console.error('Upload failed:', error);
            throw new Error(error.response?.data?.detail || 'Failed to upload file');
        }
    },

    // Get List of Documents for a Business
    async getDocuments(businessSlug: string): Promise<DocumentMetadata[]> {
        try {
            const res = await api.get(`/documents/list/${businessSlug}`);
            return res.data;
        } catch (error: any) {
            console.error('Failed to fetch documents:', error);
            throw new Error(error.response?.data?.detail || 'Failed to fetch documents');
        }
    },

    // Delete Document
    async deleteDocument(businessSlug: string, docId: string): Promise<{ message: string }> {
        try {
            const res = await api.delete(`/documents/${businessSlug}/${docId}`);
            return res.data;
        } catch (error: any) {
            console.error("Failed to delete document:", error);
            throw new Error(
                error.response?.data?.detail || "An error occurred while deleting the document."
            );
        }
    }
};

export default documentsApi;
